export default __webpack_public_path__ + "static/media/TextIcon.81987436.svg";